<div class="mat-typography errors-in-files-dialog">
  <div class="import-dialog">
    <div class="import-dialog__header">
      <span class="import-dialog__title">
        Import failed
        @if (file.upload_id) {
          <span class="file-name" [matTooltip]="file.filename">
            ({{
            file.filename | truncate:32:{
            preserveExtension: true,
            spaceBeforeExt: true
          }
          }})
        </span>
      }
    </span>
  </div>

  <div class="horizontal-separator"></div>

  <div class="import-dialog__info-message">
    <p>Please review the errors listed below, correct them, and upload the file again.</p>
  </div>

  <div class="import-dialog__error-log">
    <p class="error-log__title">Errors</p>

    <div class="error-log__header">
      <div class="error-log__header-column line">
        <span>Line</span>
      </div>
      <div class="error-log__header-column description">
        <span>Description</span>
      </div>
    </div>

    <div class="horizontal-separator internal"></div>

    @if (!logs.length && !loading) {
      <p>No logs found</p>
    }

    <cdk-virtual-scroll-viewport itemSize="50" class="error-log-viewport">
      <div *cdkVirtualFor="let log of logs" class="error-row">
        <div class="error-line">
          <div class="icon icon-failed"></div>
          Line {{ log.row_number }}
        </div>
        <div class="error-description">
          @if (log.error_message) {
            <div>• {{ log.error_message }}</div>
          }
          @if (log.error_type) {
            <div>
              • {{ log.error_type }}
            </div>
          }
        </div>
      </div>
      <div #scrollSentinel id="scroll-sentinel" class="scroll-sentinel"></div>
    </cdk-virtual-scroll-viewport>
    <!--            <div class="loading-spinner" *ngIf="loading">-->
    <!--                <mat-progress-spinner diameter="24" mode="indeterminate"></mat-progress-spinner>-->
  <!--            </div>-->
</div>
</div>

<div class="import-dialog__footer">
  <div class="import-dialog__actions">
    <button type="button" class="cancel-button" (click)="close()">Close</button>
  </div>
</div>
</div>
